export const profileOpenigQueryParamsOrigins = ['extensao-whatsapp'];
